import { DefaultDataProvider } from 'superset-dashboard-sdk';
const dp = new DefaultDataProvider("http://localhost:8088", {
  username: "guest",
  password: "guest"
});
export default dp;